module.exports = __webpack_public_path__ + "img/eco-office.98a8a52c.png";